export const createCrudFormStyles = ({
  errorFontSize = "14px !important",
  includeErrorMarginTop = false,
} = {}) => {
  const styles = {
    Card: {
      "&.css-1pwmz90-MuiPaper-root-MuiCard-root": {},
    },
    test: {
      "&.css-1y8ffmw-MuiTypography-root": {
        marginTop: "20px",
        marginBottom: "20px",
      },
    },
    heading: {
      "&..css-tp1jng-MuiCardHeader-root": {
        padding: "14px 24px 4px 25px",
      },
    },
    textfield: {
      "&.css-1u3bzj6-MuiFormControl-root-MuiTextField-root": {
        marginBottom: "20px",
      },
    },
    button: {
      "&.css-1sr3nc9-MuiButtonBase-root-MuiButton-root": {
        width: "20%",
        marginLeft: "10px",
      },
    },
    error: {
      color: "red",
      fontSize: errorFontSize,
    },
    inputError: {
      "& .MuiFilledInput-underline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        "& .MuiFilledInput-underline": {
          borderColor: "rgb(255 0 0 / 48%) !important",
        },
      },
      "& .MuiOutlinedInput-root:hover": {
        "& .MuiFilledInput-underline": {
          borderColor: "rgb(255 0 0 / 48%) !important",
        },
      },
    },
  };

  if (includeErrorMarginTop) {
    styles.errorMargingTop = {
      marginTop: "16px",
    };
  }

  return styles;
};
